import {ColumnCode, ColumnType} from 'priority-web-sdk/enums';
import {getLang} from './index';

export function getDateFormat(type, code) {
    let format;
    if (type === ColumnType.Date || type === ColumnType.Time) {
        const lang = getLang();
        if (type === ColumnType.Time) {
            format = lang === '3' ? 'hh:mm a' : 'HH:mm';
        } else {
            switch (code) {
                case ColumnCode.Date8:
                    format = lang === '3' ? 'MM/DD/YY' : 'DD/MM/YY';
                    break;
                case ColumnCode.Date10:
                    format = lang === '3' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
                    break;
                case ColumnCode.Date14:
                    format = lang === '3' ? 'MM/DD/YY hh:mm a' : 'DD/MM/YY HH:mm';
                    break;
            }
        }
    }
    return format;
}

export function getDefaultDateTimeFormat() {
    return getLang() === '3' ? 'MM/DD/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm';
}

export function getDefaultDateFormat() {
    return getLang() === '3' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
}
